import React from 'react'
import { useState } from 'react';
import './UserProfile.css';
const images = [...Array(18)].map((_, index) => (index === 0 || index === 17) ? require(`./Assets/BreatheEVUserGuide.pdf-${index + 1}.png`) : require(`./Assets/BreatheEVUserGuide.pdf-${index + 1}.svg`));

//BreatheEVUserGuide.pdf-1
const UserGuide = () => {
 
        const pdfURL = encodeURIComponent("https://s3.us-west-2.amazonaws.com/app.breathe-ev/User_Guide/BEVUserGuide.pdf");
        console.log(pdfURL)
    const viewerURL = `https://view.officeapps.live.com/op/embed.aspx?src=${pdfURL}`;
    console.log(viewerURL)
    return (
        <div className='container'>
            <div className='user-guide'>{
                
                images.map((image, index) => (
                    <img
                        key={index}
                        src={image}
                        alt={`Page ${index + 1}`}
                        style={{ width: '90%', height: 'auto', marginBottom: '10px' }}
                    />
                ))
                
            }
            </div>
           
        </div>
    );
}

export default UserGuide
{/* <div className='container' style={{ height: '100vh' }}>
            <iframe
                src='https://s3.us-west-2.amazonaws.com/app.breathe-ev/User_Guide/BEVUserGuide.pdf'
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                title="User Guide"
            ></iframe>
        </div> */}
// https://docs.google.com/viewer?url=https://morth.nic.in/sites/default/files/UserGuide.pdf&embedded=true
//https://docs.google.com/viewer?url=https://s3.us-west-2.amazonaws.com/app.breathe-ev/User_Guide/BreatheEVUserGuide.pdf+(2).pdf
{/* <iframe
                src="/UserGuide.pdf#toolbar=1&navpanes=0&scrollbar=1"
                title="User Guide"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
            /> */}